import { connect } from 'react-redux';
import { State } from 'widgets/friends-referral/root/root.reducers';
import PlatformSelection from './platform-selection.component';
import { IPlatformSelectionDispatchProps, IPlatformSelectionStoreProps } from './platform-selection.types';
import { registerUser } from '../friends-referral/friends-referral-store';

const mapStateToProps = (state: State): IPlatformSelectionStoreProps => ({
    platforms: state.friendsReferral.platformsEligibility!,
    isLoading: state.friendsReferral.loading,
    shouldInheritStyles: state.config.shouldInheritStyles
});

const mapDispatchToProps: IPlatformSelectionDispatchProps = {
    submitCallback: registerUser
};

const PlatformSelectionContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PlatformSelection);

export default PlatformSelectionContainer;
